import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
	ApiPaginatedResponse,
	CreateVehicleMakeDto,
	UpdateVehicleMakeDto,
	VehicleMakeListDto,
	VehicleMakeRecordDto,
	VehicleMakesAppOptionsDto,
	VehicleMakeSearchDto,
	VehicleMakesFilters,
	VehicleMakesStatsDto,
	VehicleModelSearchDto,
	VehicleModelsFilters,
	ModulesEnum,
} from '@splitsecondconnect/ultramarine-shared';
import { catchError, Observable, tap, throwError } from 'rxjs';

import { UltramarineApiService } from '../../../../../../../core/api/ultramarine-api.service';
import { BaseService } from '../../../../../../../shared/base-classes/base.service';

@Injectable({
	providedIn: 'root',
})
export class VehicleMakesService extends BaseService<
	VehicleMakeRecordDto,
	CreateVehicleMakeDto,
	UpdateVehicleMakeDto,
	VehicleMakeListDto,
	VehicleMakesStatsDto,
	VehicleMakesAppOptionsDto,
	VehicleMakesFilters,
	VehicleMakeSearchDto
> {
	#api = inject(UltramarineApiService);
	constructor() {
		super();
		this.relativeUrl = ModulesEnum.VEHICLE_MAKES;
		this._newRecord = undefined;
	}

	public getModelsSearchResults(
		searchQuery: string,
		searchQueryIds: number[] = undefined,
		pageSize: number = undefined,
		searchFilters: VehicleModelsFilters = undefined,
		page: number = undefined,
	): Observable<ApiPaginatedResponse<VehicleModelSearchDto[]>> {
		const filters = {
			query: searchQuery,
			queryIds: searchQueryIds,
			...searchFilters,
		};

		const pagination = {
			page: page ? page + 1 : 1,
			pageSize: pageSize,
		};
		const params = new HttpParams()
			.set('filters', filters ? JSON.stringify(filters) : '')
			.set('pagination', pagination ? JSON.stringify(pagination) : '');
		return this.#api.get(`${this.relativeUrl}/models/search`, params).pipe(
			tap((response: ApiPaginatedResponse<VehicleModelSearchDto[]>) => {}),
			catchError((error: Error) => {
				return throwError(
					() => new Error(`Could not get search results`, { cause: error }),
				);
			}),
		);
	}
}
